import { colors, fonts } from '@grupoboticario/flora-tokens/vult/web/ds'

export const vult = {
  colors,
  fonts,
}
